import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { Typography, Button, Menu, MenuItem,Paper } from "@mui/material";
import { useState } from "react";


// const data = [
//     { name: "Non-Litegation", value: 40, color: "#4141FF", description: "Cash, Bank Accounts" },
//     { name: "Litegation", value: 5, color: "#8A7FDB", description: "Taxes Payable, Loans" },
//     { name: "Trademark", value: 40, color: "#00B383", description: "Revenue generated from sales, services" },

// ];
//const rawdata = data.filter(item => item.value > 0);


const CustomPieChart = ({ coreManagement,onPeriodChange }) => {
    const [period, setPeriod] = useState("Monthly");
    const [anchorEl, setAnchorEl] = useState(null);
    console.log("core management data ******", coreManagement)
    const rawdata = coreManagement.filter(item => item.value > 0);

    const handleClose = (selectedPeriod) => {
        if (selectedPeriod) {
            setPeriod(selectedPeriod);
            onPeriodChange(selectedPeriod); 
        }
        setAnchorEl(null);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    return (
        // <div className="bg-white border border-[#C0C0C0] shadow-2xl rounded-lg p-4 h-80 col-span-3">
        // <Paper elevation={1} sx={{ p: 0, borderRadius: 0 }} sy={{p:1}}>
            <div>
            <div className="flex justify-between items-center mb-4">
                <Typography height={2} variant="h6" fontWeight="bold">
                    Pie Chart - Invoice
                </Typography>
    
                <button
                    variant="outlined"
                    onClick={handleClick}
                    className="border border-[#000000] text-[#000000] text-xs h-[30px] px-2 py-2 rounded-lg flex items-center gap-2 hover:bg-[#A9A9A9]"
                >
                    {period} <span className="text-xs">▼</span>
                </button>
    
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose(null)}>
                    <MenuItem onClick={() => handleClose("Monthly")}>Monthly</MenuItem>
                    <MenuItem onClick={() => handleClose("Yearly")}>Yearly</MenuItem>
                </Menu>
            </div>
    
            <div className="flex items-center justify-center">
                <PieChart width={260} height={260}>  {/* Adjusted size for better fit */}
                    <Pie
                        data={rawdata}
                        cx="50%"
                        cy="50%"
                        outerRadius={100}
                        label={({ cx, cy, midAngle, innerRadius, outerRadius, percent, name }) => {
                            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                            const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
                            const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
                            return (
                                <text
                                    x={x}
                                    y={y}
                                    fill="white"
                                    fontSize="16"
                                    fontWeight="bold"
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                >
                                    {`${(percent * 100).toFixed(0)}%`}
                                </text>
                            );
                        }}
                        labelLine={false}
                        dataKey="value"
                    >
                        {rawdata.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip />
                </PieChart>
    
                <div className="ml-2">
                    {coreManagement.map((item, index) => (
                        <div key={index} className="flex items-center mb-2">
                            <span
                                className="w-3 h-3 mr-2"
                                style={{
                                    width: 0,
                                    height: 0,
                                    borderLeft: '1px solid transparent',
                                    borderRight: '12px solid transparent',
                                    borderBottom: '10px solid ' + item.color,
                                }}
                            ></span>
                            <div>
                                <p>{item.name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* // </Paper> */}
        </div>
    );
    
};

export default CustomPieChart;
